import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vvideo',
  templateUrl: './vvideo.component.html',
  styleUrls: ['./vvideo.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VvideoComponent implements OnInit {

  application = "video";
  component = '';
  compose_response: any = [];
  rate = 0;
  is_owner = false;
  params: any = [];
  id = "";
  response: any = [];
  images: any = [];
  report_param: any = [];
  isLogin = false;
  btn_process = false;
  action_class: any = {};
  rate_readonly = false;
  page_load = true;
  sidetabs={"recent":"Recent","viewed":"Views","rated":"Popular","liked":"Liked","favorites":"Favorite"};
  constructor( public ngxSmartModalService: NgxSmartModalService, private _mail: MailService,  private router: Router, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }
    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.response = this._global.getVal(data, 'response', '');
            this.is_owner = this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
            this._global.addMetaInfo(this.response, 'view','name');
            this.report_param = {
              id: this.response.id,
              name: this.response.name
            };
          }else{
            this.router.navigate(['']);
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
  }
  ngOnInit() {

  }

  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  edit() {
    this.router.navigate(['/edit/' + this.application], { queryParams: { 'id': this.id } });
  }
}
